/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lump-sum investment is a single, one-time amount you invest all at once — such as a bonus, inheritance, or maturity payout — rather than spreading it out over time the way a SIP does. The whole amount starts compounding from day one, which is why timing and the return rate you choose have a bigger effect on the outcome than with a SIP.`)
};

const es_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una inversión de suma única es una cantidad única e única que inviertes de una sola vez — como una bonificación, herencia, o pago de vencimiento — en lugar de distribuirla a lo largo del tiempo como un SIP. El monto completo comienza a componerse desde el primer día, por lo que el cronometraje y la tasa de retorno que elijas tienen un efecto más grande en el resultado que con un SIP.`)
};

const de_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Pauschalanlage ist ein einzelner, einmaliger Betrag, den Sie auf einmal investieren — wie einen Bonus, Erbschaft oder Fälligkeitszahlung — anstatt es über die Zeit wie bei einem SIP zu verteilen. Der ganze Betrag beginnt vom ersten Tag an zusammenzusetzen, weshalb Timing und der Renditekurs, den Sie wählen, einen größeren Effekt auf das Ergebnis haben als mit einem SIP.`)
};

const nl_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een eenmalige belegging is één enkel, eenmalig bedrag dat u alles tegelijk belegt — bijvoorbeeld een bonus, erfenis of vervaldatum payout — in plaats van het uit te smeren zoals een SIP doet. Het hele bedrag begint onmiddellijk samen te stellen, daarom hebben timing en het rendement dat u kiest een groter effect op het resultaat dan met een SIP.`)
};

const fr_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un investissement versement unique est un montant unique, investi en une seule fois, plutôt que réparti dans le temps comme un SIP.`)
};

const it_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un investimento forfettario è un importo singolo e una tantum che investi tutto in una volta — come un bonus, un'eredità o un pagamento a scadenza — piuttosto che distribuirlo nel tempo come fa un SIP. L'intero importo inizia a capitalizzarsi dal primo giorno, motivo per cui i tempi e il tasso di rendimento che scegli hanno un effetto maggiore sul risultato rispetto a un SIP.`)
};

const pt_br2_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um investimento único é um valor único e único que você investe de uma só vez — como um bônus, herança ou pagamento de vencimento — em vez de espalhá-lo ao longo do tempo como um SIP faz. O valor total começa a se compor desde o primeiro dia, e é por isso que o tempo e a taxa de retorno que você escolhe têm um efeito maior no resultado do que com um SIP.`)
};

const pt_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um investimento em montante único é um montante individual e único que investe de uma só vez — como um bónus, herança, ou pagamento de maturidade — em vez de o espalhar ao longo do tempo como um SIP faz. O montante inteiro começa a capitalizar desde o primeiro dia, é por isso que o timing e a taxa de retorno que escolhe têm um efeito maior no resultado do que com um SIP.`)
};

const ja_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括投資は、ボーナス、相続金、満期支払いなど、一度にすべてを投資する単一のワンタイム金額です。SIPのように時間をかけて投資するのではなく、全額が初日から複利を開始するため、タイミングと選択する利率が結果に大きな影響を与えます。`)
};

const zh_sip_lumpsum_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性投资是指您一次性投入的单笔资金，如奖金、遗产或到期支付——而不是像SIP那样分散投资。整笔金额从第一天开始复利，这就是为什么投资时机和您选择的收益率对结果的影响比SIP更大。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_lumpsum_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_lumpsum_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_lumpsum_faq1_a", locale)
	if (locale === "en") return en_sip_lumpsum_faq1_a(inputs)
	if (locale === "es") return es_sip_lumpsum_faq1_a(inputs)
	if (locale === "de") return de_sip_lumpsum_faq1_a(inputs)
	if (locale === "nl") return nl_sip_lumpsum_faq1_a(inputs)
	if (locale === "fr") return fr_sip_lumpsum_faq1_a(inputs)
	if (locale === "it") return it_sip_lumpsum_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_sip_lumpsum_faq1_a(inputs)
	if (locale === "pt") return pt_sip_lumpsum_faq1_a(inputs)
	if (locale === "ja") return ja_sip_lumpsum_faq1_a(inputs)
	return zh_sip_lumpsum_faq1_a(inputs)
};